// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-privacy-policy strong{font-weight:700}.section-privacy-policy ol,.section-privacy-policy ul{margin-top:1rem;margin-left:1.5rem}.section-privacy-policy ul{list-style-type:disc}.section-privacy-policy ol{list-style-type:decimal}.section-privacy-policy li{margin-bottom:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
